import { createTheme } from "@mui/material";

let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#373435",
      light: "#5c5a5b",
      dark: "#1c1a1b",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#F2AD00",
      light: "#FFD04D",
      dark: "#C48A00",
      contrastText: "#1A1A1A",
    },
    success: {
      main: "#2E7D32",
      light: "#4CAF50",
      dark: "#1B5E20",
    },
    error: {
      main: "#C62828",
      light: "#EF5350",
      dark: "#8E0000",
    },
    warning: {
      main: "#E65100",
      light: "#FF8F00",
      dark: "#BF360C",
    },
    info: {
      main: "#0277BD",
      light: "#29B6F6",
      dark: "#01579B",
    },
    background: {
      default: "#d2d3d5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1A1A2E",
      secondary: "#5A6478",
      disabled: "#9AA3B0",
    },
    divider: "#E2E8F0",
    neutral: {
      50: "#F8FAFC",
      100: "#F1F5F9",
      200: "#E2E8F0",
      300: "#CBD5E1",
      400: "#94A3B8",
      500: "#64748B",
      600: "#475569",
      700: "#334155",
      800: "#1E293B",
      900: "#0F172A",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.01em" },
    h3: { fontWeight: 600, letterSpacing: "-0.01em" },
    h4: { fontWeight: 600, letterSpacing: "-0.005em" },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
    button: { fontWeight: 600, textTransform: "none", letterSpacing: "0.01em" },
    caption: { fontWeight: 400 },
    overline: { fontWeight: 600, letterSpacing: "0.08em" },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    "none",
    "0px 1px 2px rgba(0,0,0,0.06), 0px 1px 3px rgba(0,0,0,0.1)",
    "0px 1px 5px rgba(0,0,0,0.07), 0px 2px 4px rgba(0,0,0,0.06)",
    "0px 2px 8px rgba(0,0,0,0.08), 0px 4px 6px rgba(0,0,0,0.05)",
    "0px 4px 12px rgba(0,0,0,0.08), 0px 6px 10px rgba(0,0,0,0.06)",
    "0px 6px 16px rgba(0,0,0,0.09), 0px 8px 14px rgba(0,0,0,0.06)",
    "0px 8px 20px rgba(0,0,0,0.1), 0px 10px 18px rgba(0,0,0,0.06)",
    "0px 10px 24px rgba(0,0,0,0.1)",
    "0px 12px 28px rgba(0,0,0,0.1)",
    "0px 14px 32px rgba(0,0,0,0.1)",
    "0px 16px 36px rgba(0,0,0,0.1)",
    "0px 18px 40px rgba(0,0,0,0.1)",
    "0px 20px 44px rgba(0,0,0,0.1)",
    "0px 22px 48px rgba(0,0,0,0.1)",
    "0px 24px 52px rgba(0,0,0,0.1)",
    "0px 26px 56px rgba(0,0,0,0.1)",
    "0px 28px 60px rgba(0,0,0,0.1)",
    "0px 30px 64px rgba(0,0,0,0.1)",
    "0px 32px 68px rgba(0,0,0,0.1)",
    "0px 34px 72px rgba(0,0,0,0.1)",
    "0px 36px 76px rgba(0,0,0,0.1)",
    "0px 38px 80px rgba(0,0,0,0.1)",
    "0px 40px 84px rgba(0,0,0,0.1)",
    "0px 42px 88px rgba(0,0,0,0.1)",
    "0px 44px 92px rgba(0,0,0,0.1)",
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 20px",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        contained: {
          "&:hover": { boxShadow: "0px 2px 8px rgba(0,0,0,0.15)" },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
        rounded: { borderRadius: 12 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: "0px 2px 8px rgba(0,0,0,0.08), 0px 4px 6px rgba(0,0,0,0.05)" },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 500 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 600, color: "#334155" },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { borderRadius: 6, fontSize: "0.75rem" },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: "0px 1px 3px rgba(0,0,0,0.12)" },
      },
    },
  },
});

export default theme;
